import { getMessage } from "~/modules/error/ErrorCode/ErrorCodeHelper";
import { ErrorCode } from "~/modules/error/ErrorCode/ErrorCodes";
import { ErrorSeverity } from "~/modules/error/ErrorSeverity/ErrorSeverity";
import { FlexSdkErrorMetadata } from "~/modules/error/FlexSdkErrorMetadata/FlexSdkErrorMetadata";





export class FlexSdkError extends Error {
    readonly #details: string | undefined;

    readonly #errorCode: ErrorCode;

    readonly #metadata: FlexSdkErrorMetadata;

    constructor(errorCode: ErrorCode, metadata?: FlexSdkErrorMetadata, details?: string, cause?: unknown) {
        const baseMessage = getMessage(errorCode);
        const detailsMessage = details ? `: ${details}` : "";
        const codeMessage = ` (${errorCode})`;
        const message = `${baseMessage}${detailsMessage}${codeMessage}`;
        super(message, { cause });
        this.#errorCode = errorCode;
        this.#details = details;
        this.#metadata = metadata ?? { severity: ErrorSeverity.Error };

        Object.setPrototypeOf(this, FlexSdkError.prototype);
    }

    





    public get code(): ErrorCode {
        return this.#errorCode;
    }

    





    public get details(): string | undefined {
        return this.#details;
    }

    





    public get metadata(): FlexSdkErrorMetadata {
        return { ...this.#metadata };
    }
}
